import * as t from 'io-ts';
import _ from 'lodash';

import {parseAccount, RAccount} from './accountModel';
import {makeApiType} from './apiTypes';
import {parseTeammate, RTeammate} from './teammateModel';

/*
 * Runtime type.
 */

const RSearchAccountsV2Dirty = t.readonly(
  t.type({
    nextPageToken: t.union([t.string, t.undefined]),
    accounts: t.readonlyArray(RAccount),
    teammates: t.readonlyArray(RTeammate),
    limit: t.union([t.number, t.undefined]),
  }),
);

/*
 * Type.
 */

interface SearchAccountsV2Model extends t.TypeOf<typeof RSearchAccountsV2Dirty> {}
const RSearchAccountsV2 = t.clean<SearchAccountsV2Model>(RSearchAccountsV2Dirty as any);

/*
 * IO methods.
 */

function parseSearchAccountsV2(src: any): SearchAccountsV2Model {
  return {
    nextPageToken: src.next_page_token,
    accounts: src.accounts && src.accounts.map((account: any) => parseAccount(account)),
    teammates: _(src.accounts)
      .map((account: any) => account.owner && parseTeammate(account.owner))
      .compact()
      .value(),
    limit: src.limit,
  };
}

/*
 * API type.
 */

export const ApiSearchAccountsV2 = makeApiType('searchAccountsV2', RSearchAccountsV2, parseSearchAccountsV2);
